module.exports = __webpack_public_path__ + "static/media/backButton.8b8a1d99.svg";